import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthFacade } from './state/auth.facade';
import CONSTANTS from 'src/app/util/Constant';

@Injectable({
  providedIn: 'root'
})
export class DefaultRoutGuard implements CanActivate {
  constructor(public router: Router, private authFacade: AuthFacade) {}
  canActivate(): Observable<UrlTree> {
    return this.authFacade.user$.pipe(
      map((user) => {
        const module = user.userRole[0].modules.find((m: any) => m.shortName === CONSTANTS.OM);
        const defaultRoute =
          module && module.defaultScreen && module.defaultScreen.value
            ? module.defaultScreen.value
            : CONSTANTS.DEFAULT_ROUTING;
        console.log('defaultRoute', defaultRoute);
        return this.router.createUrlTree([defaultRoute]);
      })
    );
  }
}
